import { ref } from 'vue'
import ValidationObserver from '@/components/validation/ValidationObserver.vue'

export default function() {
  const validationObserver = ref()

  /**
   * 画面内（同一コンポーネント内）で validate を使う箇所が一つだけであれば、この Composition function 内の validationObserver Ref オブジェクトを使用する形（メソッド使用の際の引数はなし）で問題ないが、
   * 画面内に複数の ValidationObserver が存在しており、複数の validate をつつくトリガーが存在している場合は、同じ Ref オブジェクトを参照する形となり、後で記述したものに上書きされてしまうため、
   * その場合は、コンポーネント側でそれぞれの Ref オブジェクトを定義した上で、メソッド使用の際は引数にそれぞれの Ref オブジェクトを渡すこと。
   *
   * @param observer 対象の ValidationObserver の Ref オブジェクト（コンポーネント Ref）
   * @returns 全項目がバリデーションを通過したかどうか
   * @example
   *  ... 前略 ...
   *  const validationObserverFoo = ref()
   *  return {
   *    validationObserverFoo,
   *  }
   *  </script>
   *
   *  <template>
   *    <ValidationObserver ref="validationObserverFoo">
   *      ... 中略 ...
   *    </ValidationObserver>
   *  </template>
   */
  const validate = (observer?: InstanceType<typeof ValidationObserver>): Promise<boolean> => {
    const observerEl = observer ?? validationObserver.value
    return observerEl.validate()
  }

  return {
    // data
    validationObserver,

    // method
    validate,
  }
}
